import { IndexType } from '../../seo/constants'
import { Location } from '../../../types/models/Location.model'
import { LOCATION_TYPE } from '../constants'

export const getIndexTypeForLocation = (
  location: Pick<Location, 'type'>
): IndexType => {
  if (location.type === LOCATION_TYPE.REGION) {
    return IndexType.REGION_FACET_ONLY
  }

  if (location.type === LOCATION_TYPE.COUNTRY) {
    return IndexType.COUNTRY_FACET_ONLY
  }

  return IndexType.FULL_INDEX
}
